/* eslint-disable react/no-array-index-key */
import React from 'react';
import { Accordion } from 'react-bootstrap';

import { __ } from '../../../helpers/translations';
import Section from '../../common/Section';

import SectionHeader from './SectionHeader';

const faqItems = [
  {
    question: __('G315'),
    answer: [__('G316')],
  },
  {
    question: __('G317'),
    answer: [__('G318')],
  },
  {
    question: __('G319'),
    answer: [__('G320'), __('G321')],
  },
  {
    question: __('G322'),
    answer: [__('G323')],
    link: {
      text: 'ITP Metrics Updates - Creating an Assessment',
      url: './resources/ITP_Metrics_Updates_-_Creating_an_Assessment.pdf',
    },
  },
  {
    question: __('G324'),
    answer: [__('G325')],
    link: {
      text: 'ITP Metrics Updates - Completing and Accessing Reports',
      url: './resources/ITP_Metrics_Updates_-_Accessing_Reports.pdf',
    },
  },
];

function FAQ() {
  return (
    <Section>
      <SectionHeader
        title={__('G314')}
        subtitle=""
      />

      <Accordion defaultActiveKey="0">
        {faqItems.map((item, index) => (
          <Accordion.Item eventKey={index} key={`faq-${index}`}>
            <Accordion.Header>{item.question}</Accordion.Header>
            <Accordion.Body>
              {item.answer.map(
                (answer, answerIndex) => <p key={`faq-${index}-answer-${answerIndex}`}>{answer}</p>,
              )}
              {item.link
              && (
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={item.link.url}
              >
                {item.link.text}
              </a>
              )}
            </Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>

    </Section>
  );
}

export default FAQ;
